'use client';

import { useState } from 'react';

export default function Tabs({ tabs }) {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="w-full">
      <div className="tabs">
        {tabs?.map(({ id, title }, index) => (
          <div
            key={`tab-title-${id}`}
            className={
              activeTab === index
                ? 'tab tab-lg tab-bordered tab-active text-sm bg-base-100'
                : 'tab tab-lg tab-bordered text-sm bg-base-100'
            }
            onClick={() => setActiveTab(index)}
          >
            <div className="flex items-center space-x-2">
              <span>{title}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="tab-content">{tabs[activeTab]?.content}</div>
    </div>
  );
}
